// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2967":"cbbe398d","5093":"915ed2df"}[chunkId] + ".chunk.css";
};